/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const FavouriteBorder = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_2860_20262)">
        <path
          d="M13.6 2.7998C12.208 2.7998 10.872 3.4478 10 4.4718C9.128 3.4478 7.792 2.7998 6.4 2.7998C3.936 2.7998 2 4.7358 2 7.1998C2 10.2238 4.72 12.6878 8.84 16.4318L10 17.4798L11.16 16.4238C15.28 12.6878 18 10.2238 18 7.1998C18 4.7358 16.064 2.7998 13.6 2.7998ZM10.08 15.2398L10 15.3198L9.92 15.2398C6.112 11.7918 3.6 9.51181 3.6 7.1998C3.6 5.5998 4.8 4.3998 6.4 4.3998C7.632 4.3998 8.832 5.1918 9.256 6.2878H10.752C11.168 5.1918 12.368 4.3998 13.6 4.3998C15.2 4.3998 16.4 5.5998 16.4 7.1998C16.4 9.51181 13.888 11.7918 10.08 15.2398Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2860_20262">
          <rect width="19.2" height="19.2" fill="white" transform="translate(0.400024 0.400391)" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default FavouriteBorder
